/*============================================================================
  Scripts for Technocolor Lead Generation templates ONLY
==============================================================================*/
$(document).ready(function() {    
  
    colorBarOnScroll();
    addClassToFooter();
    technocolorTab();
    toggleToolTip();
    if ( $('.technocolor-real-reviews-section').length ) {
        getTestimonial();
    }
    miniRetailerSlider();
    miniRetailerSliderTop();
    adjustTechnocolorHeaderSticky();
});

// on mobile, remove margin top when scrolling
function colorBarOnScroll() {
    let lastFixPos = 0;
    let threshold = 30;

    $(window).on('scroll', function(){
    let diff = Math.abs($(window).scrollTop() - lastFixPos);
    if(diff > threshold){
        $('.lead-generation-technocolor').addClass('remove-top');
    } else {
        $('.lead-generation-technocolor').removeClass('remove-top');
    }
    });
}


function addClassToFooter() {
    if ( $('.lead-generation-technocolor').length ) {
        $('#shopify-section-footer-classic').addClass('lead-gen-footer');
    }
}

// technocolor tabs function
function technocolorTab() {  
    $('.shopify-section').each( function() {
        if ( $(this).find('.technocolor-tabs').length ) {
            
            let tabId = $(this).attr('id');
            let tab = $('#'+tabId+' '+ '.technocolor-tab-nav');
            let item = $('#'+tabId+' '+ '.technocolor-tab-nav li.active a').attr('class');
            
            // Show the first tab and hide the rest
            if ( !$('#'+tabId+' '+ '.technocolor-tab-nav li').hasClass('active') ) {
                $(tab).find('li:first-child').addClass('active');
                
                // $('#'+tabId+' '+ '#'+item).show();
                setTimeout( function() {
                    $('#'+tabId+' '+ '.main-tab-content:first').show();
                },1000)
            }

            $('#'+tabId+' '+ '.main-tab-content').hide();
            $('#'+tabId+' '+ '#'+item).show();

            // Click function
            $(tab).find('li').on( 'click', function() {
                $(tab).find('li').removeClass('active');
                $(this).addClass('active');
                $('#'+tabId+' '+ '.main-tab-content').hide();

                let activeTab = $(this).find('a').attr('href');
                
                $('#'+tabId+' '+ activeTab).fadeIn();

                //check if testimonial slider is available
                //this is to avoid tab and slider bug rendering
                if ( $('#'+tabId).find('.testimonial-container').hasClass('slick-initialized') ) {
                    setTimeout( function() {
                        $('#'+tabId+' '+ activeTab).find('.testimonial-container').slick('setPosition'); 
                    },100)
                    
                }
                
                return false;
            })
        }
        
    });
    
} 

// technocolor toggle bundle section tootip 
function toggleToolTip() {
    
    let $btn = $('.eb-tooltip-open');

    $btn.on('click', function() {
        if ( $(this).parent().hasClass('active') ) {
            $(this).parent().removeClass('active');
        } else {
            $(this).parent().addClass('active');
        }
    });
}

/// Image comparison slider
function initComparisons() {
    var x, i;
    /*find all elements with an "overlay" class:*/
    x = document.getElementsByClassName("img-comp-overlay");
    for (i = 0; i < x.length; i++) {
      /*once for each "overlay" element:
      pass the "overlay" element as a parameter when executing the compareImages function:*/
      if (x[i].offsetWidth > 0) {
        compareImages(x[i], i);
      }
    }
    function compareImages(img, index) {
      var slider, img, clicked = 0, w, h;
      /*get the width and height of the img element*/
      w = $('.img-comp-container')[index].offsetWidth;
      h = img.offsetHeight;
      /*set the width of the img element to 50%:*/
      img.style.width = (w / 2) + "px";
      /*create slider:*/
      $($('.img-comp-container')[index]).find('.img-comp-slider').remove();
      slider = document.createElement("DIV");
      slider.setAttribute("class", "img-comp-slider");
      /*insert slider*/
      img.parentElement.insertBefore(slider, img);
      /*position the slider in the middle:*/
      slider.style.top = (h / 2) - (slider.offsetHeight / 2) + "px";
      slider.style.left = (w / 2) - (slider.offsetWidth / 2) + "px";
      /*execute a function when the mouse button is pressed:*/
      slider.addEventListener("mousedown", slideReady);
      /*and another function when the mouse button is released:*/
      window.addEventListener("mouseup", slideFinish);
      /*or touched (for touch screens:*/
      slider.addEventListener("touchstart", slideReady);
      /*and released (for touch screens:*/
      window.addEventListener("touchend", slideFinish);
      function slideReady(e) {
        /*prevent any other actions that may occur when moving over the image:*/
        e.preventDefault();
        /*the slider is now clicked and ready to move:*/
        clicked = 1;
        /*execute a function when the slider is moved:*/
        window.addEventListener("mousemove", slideMove);
        window.addEventListener("touchmove", slideMove);
      }
      function slideFinish() {
        /*the slider is no longer clicked:*/
        clicked = 0;
      }
      function slideMove(e) {
        var pos;
        /*if the slider is no longer clicked, exit this function:*/
        if (clicked == 0) return false;
        /*get the cursor's x position:*/
        pos = getCursorPos(e)
        /*prevent the slider from being positioned outside the image:*/
        if (pos < 0) pos = 0;
        if (pos > w) pos = w;
        /*execute a function that will resize the overlay image according to the cursor:*/
        slide(pos);
      }
      function getCursorPos(e) {
        var a, x = 0;
        e = (e.changedTouches) ? e.changedTouches[0] : e;
        /*get the x positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x coordinate, relative to the image:*/
        x = e.pageX - a.left;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        return x;
      }
      function slide(x) {
        /*resize the image:*/
        img.style.width = x + "px";
        /*position the slider:*/
        slider.style.left = img.offsetWidth - (slider.offsetWidth / 2) + "px";
      }
    }
  }
  
/*Execute a function that will execute an image compare function for each element with the img-comp-overlay class:*/
initComparisons();

// reinit img + testimonial sliders on product change
$('.product-image-wrapper .product-image').click(function() {
    initComparisons();
    $('.testimonial-container').slick('slickGoTo', 0);
});

// slider settings
function getSliderSettings() {
    return {
        arrows: false,
        dots:true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        refresh: true
    }
}
// testimonial slider init
function getTestimonial() {
    $('.get-testimonials .testimonial-item').each( function() {
        
        let test_id = $(this).attr('class');
        let id = test_id.split(' ');
        let item = $(this).parent().find('.'+id[1]);
        $('#'+id[1]+' '+'.testimonial-container').append(item)
    });
    $('.technocolor-real-reviews-section .main-tab-content').each( function() {
        let slide = $(this).find('.testimonial-container');
        $(slide).slick(getSliderSettings());
    });
}

function miniRetailerSlider() {
    let slide = $('.mini-retailer-slider');
    if ( $(slide).length ) {
        $(slide).slick(getSliderSettings());
    } 
}

function miniRetailerSliderTop() {
    let slide = $('.mini-retailer-slider-top');
    if ( $(slide).length ) {
        $(slide).slick(getSliderSettings());
        
        if ( $(slide).find('.mini-retailer-slide').length == 1 ) {
            $(slide).addClass('no-dots')
        }
    } 
}

function adjustTechnocolorHeaderSticky() {
    setInterval(() => {
        if ($('.technocolor-header-included, .technohub-wrapper')) {
            if($('#mobile-header-sticky-wrapper').hasClass('is-sticky')) {
                $('.technocolor-header-included').addClass('is-sticky');
                $('.technohub-wrapper').addClass('is-sticky');
            }
            else {
                $('.technocolor-header-included').removeClass('is-sticky');
                $('.technohub-wrapper').removeClass('is-sticky');
            }
        }
    });
};